/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationPipelineConfigDataSchema = z.object({
	stages: z.array(
		z.object({ name: z.string(), id: z.string().nullable().optional(), locked: z.boolean().nullable().optional() }),
	),
})

export type UpdateOrganisationPipelineConfigDataSchema = z.infer<typeof updateOrganisationPipelineConfigDataSchema>
